"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eventTypes = void 0;
exports.eventTypes = {
    CONNECTION: {
        CONNECT: 'connection',
        ERROR: 'connection_error',
    },
    SESSION: {
        CREATED: 'session:created',
        EXPIRED: 'session:expired',
        INVALID: 'accessToken:invalid',
    },
    CHAT: {
        CREATE: 'chat:create',
        CREATED: 'chat:created',
        UPDATE: 'chat:update',
        TITLE_SET: 'chat:title-set',
        PROMPT_SUPPORT: 'chat:prompt:support',
        ERROR: 'chat:error',
        ERROR_LIMIT_REACHED: 'chat:error:limit-reached',
        ERROR_SERVICE: 'chat:error:service',
    },
    MESSAGE: {
        MESSAGE: 'message',
        RESPONSE: 'message:response',
        TYPING: 'response:typing',
        AGENT_TYPING: 'response:agent-typing',
        FEEDBACK: 'message:feedback',
    },
    ERROR: {
        ERROR: 'message:error',
        ERROR_LIMIT_REACHED: 'message:error:limit-reached',
        ERROR_SERVICE: 'message:error:service',
    },
};
